import type { FormCompositionHook } from '@ipfabric/ui-components/utils/formSnippets/useFormComposition';

type Props = {
  formComposition: FormCompositionHook<'aimFlows'>;
};

export const AimFlowsSubTab = ({ formComposition }: Props) => (
  <div className='flex flex-col flex-1 gap'>
    {formComposition.renderGroup('aimFlows')}
  </div>
);
